<script lang="ts" setup>
import { Employee } from '../../components/EmployeeSingle.vue'

defineProps<{
  title: string
  persons: Employee[]
}>()
</script>

<template>
  <ToccoContactPersons :title="title" :persons="persons" />
</template>
